import React, { useEffect, useState } from "react";
import "./Advisories.css";
import DateFilter from "../../components/DateFilter/DateFilter";
import { fetchAdvisories } from "../../app/slices/advisoriesSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { dateFormat, oracleDateFormat } from "../../app/utils";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import EmptyDataContainer from "../../components/EmptyDataContainer/EmptyDataContainer";

const Advisories = () => {
  const {
    data: advisoriesList,
    status: statusAdvisories,
    error: errorAdvisories,
  } = useSelector(({ advisories }) => advisories.get);

  const [formValues, setFormValues] = useState({
    fromDate: moment().subtract(3, "years").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    status: "A",
  });

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    handleSubmit();
  }, []);

  //methods
  const handleSubmit = () => {
    dispatch(
      fetchAdvisories({
        start_date: formValues?.fromDate
          ? moment(formValues?.fromDate).format(oracleDateFormat)
          : null,
        end_date: formValues?.toDate
          ? moment(formValues?.toDate).format(oracleDateFormat)
          : null,
        status: formValues?.status,
      })
    );
  };

  //builders

  const BuildListItem = ({ advisory }) => {
    return (
      <a href={`advisories/advisory-details?id=${advisory?.advisory_id}`}>
        <div className="advisory-item">
          <h3>{advisory?.title}</h3>
          <small>Reference:</small>
          <p>{advisory?.reference_number}</p>
          <small>Published On:</small>
          <p>{moment(advisory?.published_date).format(dateFormat)}</p>
        </div>
      </a>
    );
  };

  return (
    <div className="advisories app-padding">
      <DateFilter
        formValues={formValues}
        setFormValues={setFormValues}
        handleSubmit={handleSubmit}
      />
      <section className="mb-30">
        {statusAdvisories === "idle" && errorAdvisories === null && (
          <div className="flex-row flex-wrap">
            {advisoriesList?.map((item) => (
              <BuildListItem advisory={item} />
            ))}
          </div>
        )}

        {statusAdvisories === "loading" && (
          <LoadingContainer message={"Loading please wait..."} />
        )}

        {advisoriesList?.length === 0 && statusAdvisories === "idle" && (
          <EmptyDataContainer message={"Nothing found"} />
        )}

        {errorAdvisories && statusAdvisories !== "loading" && (
          <ErrorContainer
            message={errorAdvisories?.message}
            onReload={() => {
              handleSubmit();
            }}
          />
        )}
      </section>
    </div>
  );
};

export default Advisories;
